// This script connects the search modal trigger buttons with the Alpine.js modal
document.addEventListener('DOMContentLoaded', () => {
  console.log('SearchModal: Initializing...');

  // Set up keyboard shortcuts
  document.addEventListener('keydown', (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      console.log('SearchModal: Cmd/Ctrl+K pressed');
      window.dispatchEvent(new CustomEvent('open-search'));
    }
  });

  // Set up search triggers
  const triggers = document.querySelectorAll('[data-search-modal-trigger]');
  console.log('SearchModal: Found triggers:', triggers.length);

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      console.log('SearchModal: Trigger clicked', event.target);
      window.dispatchEvent(new CustomEvent('open-search'));
    });
  });
});
